import { memo } from 'react';
import { PasswordReset } from 'src/pages/PasswordReset/PasswordReset';

export default memo(PasswordReset);
